
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-streamer",
      function () {
        return require("private-next-pages/live-streamer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-streamer"])
      });
    }
  